import { ElementType, FC, HTMLAttributes, ReactNode } from 'react';

import { Tooltip, Typography } from 'antd';
import cn from 'classnames';

import styles from './CatalogLabel.module.scss';

interface ICatalogLabelProps extends HTMLAttributes<HTMLButtonElement> {
	color: string;
	backgroundColor: string;
	Icon: ElementType;
	label?: string;
	tooltip?: ReactNode;
	value?: string;
}

export const CatalogLabel: FC<ICatalogLabelProps> = ({
	className,
	color,
	Icon,
	backgroundColor,
	label,
	tooltip,
	value,
	onClick,
	...props
}) => {
	return (
		<Tooltip title={tooltip}>
			<button
				{...props}
				onClick={onClick}
				className={cn(className, styles.button)}
				style={{
					backgroundColor: backgroundColor,
					paddingLeft: value ? 12 : 8,
					paddingRight: label ? 12 : 8,
					cursor: onClick ? 'pointer' : 'default',
				}}>
				{value && (
					<Typography.Text
						style={{
							fontSize: 24,
							fontWeight: 600,
							lineHeight: '28px',
						}}>
						{value}
					</Typography.Text>
				)}

				<Icon width={24} height={24} style={{ color: color }} />

				{label && (
					<Typography.Text
						style={{
							color: color,
						}}>
						{label}
					</Typography.Text>
				)}
			</button>
		</Tooltip>
	);
};
